var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Highcharts',_vm._g(_vm._b({ref:"chart",attrs:{"options":_vm.mergedOption}},'Highcharts',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }